"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const TooltipPoint_1 = require("../entities/TooltipPoint");
const TooltipBuilder_1 = __importDefault(require("./TooltipBuilder"));
const TABLET_BREAKPOINT = 770;
class TooltipManager {
    constructor(tooltip, timeFormatter, onlyTimeFormatter, onlyDateFormatter, fontSize) {
        this._tooltipBuilder = new TooltipBuilder_1.default();
        this._hasSameDates = false;
        this._tooltip = tooltip;
        this._tooltipPoints = [];
        this._eventPoint = null;
        this._timeFormatter = timeFormatter || this.defaultTimeFormatter;
        this._onlyTimeFormatter = onlyTimeFormatter || this._timeFormatter;
        this._onlyDateFormatter = onlyDateFormatter || this._timeFormatter;
        this._fontSize = fontSize;
    }
    hideTooltip() {
        this._tooltipBuilder.clear();
        this._tooltip
            .style("opacity", 0)
            .style("display", "none");
    }
    removeTooltip() {
        this._tooltip.remove();
    }
    getTooltipWidth() {
        const tooltipDimensions = this._tooltip.node().getBoundingClientRect();
        if (tooltipDimensions != null)
            return tooltipDimensions.width;
        else
            return 0;
    }
    getTooltipHeight() {
        const tooltipDimensions = this._tooltip.node().getBoundingClientRect();
        if (tooltipDimensions != null)
            return tooltipDimensions.height;
        else
            return 0;
    }
    showTooltip(leftPos, topPos) {
        const tooltipText = this.createTooltipText(this._tooltipPoints, this._eventPoint, this.hasWeights());
        if (tooltipText == null)
            return this.hideTooltip();
        this._tooltip.html(tooltipText)
            .classed("chart-tooltip", true)
            .attr("style", "left:" + leftPos + "px; top:" + (topPos - 50) + "px")
            .style('font-size', this._fontSize ? this._fontSize : '12px');
    }
    addTooltipPoint(point) {
        const existingPointIndex = this._tooltipPoints.findIndex(x => x.id == point.id);
        if (existingPointIndex < 0) {
            this._tooltipPoints.push(point);
        }
        else
            this._tooltipPoints[existingPointIndex] = point;
    }
    setEventPoint(point) {
        this._eventPoint = point;
    }
    removeEventPoint() {
        this._eventPoint = null;
    }
    removeTooltipPoint(index) {
        this._tooltipPoints = this._tooltipPoints.filter(x => x.id != index);
    }
    destroyTooltipElements() {
        this.hideTooltip();
        this._tooltipPoints = [];
        this._eventPoint = null;
    }
    get tooltip() {
        return this._tooltip;
    }
    createTooltipText(tooltipPoints, eventPoint, hasWeight) {
        if (tooltipPoints.length < 1)
            return null;
        else
            return this.createPointTooltipText(tooltipPoints, eventPoint, hasWeight);
    }
    createPointTooltipText(tooltipPoints, eventPoint, hasWeight) {
        let hasNameRemoved = true;
        if (window.innerWidth < TABLET_BREAKPOINT) {
            hasNameRemoved = false;
        }
        this._tooltipBuilder.initTooltip();
        this._tooltipBuilder.createSectionHead(this.findDateRange(tooltipPoints));
        tooltipPoints = tooltipPoints.sort(TooltipPoint_1.TooltipPoint.compareYValues);
        if (tooltipPoints.length > 0) {
            this._tooltipBuilder.createPointsSection(hasWeight);
            tooltipPoints.forEach(point => {
                this._tooltipBuilder.addToSection(point, this._hasSameDates ? this._onlyTimeFormatter : this._timeFormatter, hasNameRemoved);
            });
            this._tooltipBuilder.endSection();
        }
        if (eventPoint != null) {
            this._tooltipBuilder.createSectionHead("Event points");
            this._tooltipBuilder.createNewTimeSection(this._timeFormatter(eventPoint.time));
            this._tooltipBuilder.addToSection(eventPoint, this._onlyTimeFormatter, hasNameRemoved);
            this._tooltipBuilder.endSection();
        }
        return this._tooltipBuilder.build();
    }
    findDateRange(tooltipPoints) {
        const max = Math.max.apply(Math, tooltipPoints.map(function (o) { return o.time; }));
        const min = Math.min.apply(Math, tooltipPoints.map(function (o) { return o.time; }));
        const formattedMin = this._onlyDateFormatter(min);
        const formattedMax = this._onlyDateFormatter(max);
        if (formattedMin == formattedMax) {
            this._hasSameDates = true;
            return `${formattedMin}`;
        }
        else {
            this._hasSameDates = false;
            return `${formattedMin} - ${formattedMax}`;
        }
    }
    findPointsByTime(tooltipPoints, time) {
        return tooltipPoints.filter(x => x.time == time);
    }
    getTimesFromData(tooltipPoints) {
        const times = new Array();
        tooltipPoints.forEach(point => {
            if (!times.includes(point.time)) {
                times.push(point.time);
            }
        });
        return times;
    }
    hasWeights() {
        const weight = this._tooltipPoints.find(x => x.weight != null);
        if (weight != null)
            return true;
        else
            return false;
    }
    defaultTimeFormatter(time) {
        return new Date(time).toISOString();
    }
}
exports.default = TooltipManager;
